<template>
  <router-link :to="go_to()" class="client_request link">
    <tr>
      <td :data-label="translate('client_request.id')" class="w50">
        {{ client_request.id }}
      </td>
      <td :data-label="translate('client_request.date')" class="limit">
        <span :class="!check_date_today(client_request.date) ? 'future' : ''">
          {{ client_request.date }}
        </span>
      </td>
      <td :data-label="translate('client_request.type')" class="">
        <span class="badge" :style="'background-color: ' + new_type.color">
          {{ new_type.title }}
        </span>
      </td>
      <td :data-label="translate('client_request.status')" class="limit">
        <span class="badge" :style="'background-color: ' + new_status.color">
          {{ new_status.title }}
        </span>
      </td>
      <td :data-label="translate('client_request.priority')" class="limit">
        {{ client_request.priority_descr}}
      </td>
      <td :data-label="translate('client_request.simcards_state')" class="limit">
        {{ client_request.simcards_state}}
      </td>

<!--      <td :data-label="translate('client_request.working_simcard_count')" class="w70">-->
<!--        {{ client_request.simcard_count }}-->
<!--      </td>-->

      <td :data-label="translate('client_request.device_tariff')" class="device_tariff w50">
        <span v-if="client_request.device_tariffication" class="mdi mdi-currency-rub device_tariff"/>
      </td>

      <td :data-label="translate('client_request.client_name')" class="" @click.alt.stop.prevent="add_in_filter('client_id', client_request.client_id)">
        {{ client_request.client_name }}
      </td>
      <td :data-label="translate('client_request.device_status')" class="device_status w50">
        <span class="mdi" :class="client_request.device_status ? 'mdi-access-point' : 'mdi-access-point-off'" ></span>
      </td>
      <td :data-label="translate('client_request.device_name')" class="device_name w15per">
        <p class="device_name__line">
          <router-link :to="{path: '/device/' + client_request.device_fid}">
            {{ client_request.device_fid }}
          </router-link>
          <span>{{ client_request.device_name }}</span>
        </p>
      </td>

      <td :data-label="translate('client_request.simcards')" class="sim_status" v-if="$store.getters.getPermissions.permissionGod === true">
        <DeviceSimcards :simcards="client_request.device_simcards_uptime" />
      </td>

      <td :data-label="translate('client_request.device_ver')" class="device_name">
        <p v-if="client_request.device_ver?.hw">hw:{{ client_request.device_ver.hw }}</p>
        <p v-if="client_request.device_ver?.fw">fw:{{ client_request.device_ver?.fw }}</p>
      </td>
      <td :data-label="translate('client_request.device_group_name')" class="device_name">
        {{ client_request.device_group_name }}
      </td>
      <td :data-label="translate('client_request.who_created')">
        {{ client_request.user_name }}
      </td>
      <td :data-label="translate('client_request.created')" v-html="get_date_any_lines(client_request.ts_create, null, 2)"></td>
      <td :data-label="translate('client_request.completed')" v-html="client_request.ts_complete ? get_date_any_lines(client_request.ts_complete, null, 2) : ''"></td>
    </tr>
  </router-link>
</template>
<script>
import DeviceSimcards from 'components/UIComponents/DeviceSimcards/DeviceSimcards.vue'

export default {
  name: 'ClientRequestListItem',
  components: {
    DeviceSimcards
  },
  props: ["client_request", "client_order_statuses"],
  data () {
    return {
    }
  },
  computed:{
    new_status(){
      let result = this.$store.getters.getClientRequestsInfo.statuses.find((entry) => {
        if (entry.id === this.client_request.status){
          return entry
        }
      })
      return result ? {...result, title: this.translate("client_request.statuses." + result.title) } : {title: "Error", color: "red"}
    },
    new_type(){
      let result = this.$store.getters.getClientRequestsInfo.types.find((entry) => {
        if (entry.id === this.client_request.type){
          return entry
        }
      })
      return result ? {...result, title: this.translate("client_request.types." + result.title) } : {title: "Error", color: "red"}
    }
  },
  methods: {
    check_date_today(dateStr) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const d = new Date(dateStr);
      d.setHours(0, 0, 0, 0);

      return d <= today; // true если дата сегодня или раньше
    },
    go_to() {
      return { path: '/client_request/' + this.client_request.id }
    },
    add_in_filter (type, value) {
      let params = {
        type: type,
        value: value
      }
      this.$emit("add_in_filter", params)
    }

  }
}
</script>

<style lang="scss" scoped>
.client_request{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    overflow: hidden;
    vertical-align: middle;
    font-size: 12px;
    &.limit{
      width: 6%;
      min-width: 100px;
      @media (max-width: 767px) {
        width: 100%;
      }
    }

    &.device_tariff{
      color: #3f93d3;
      font-size: 18px;
      vertical-align: middle;
      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
    .future{
      font-weight: bold;
      color: #dfce53;
    }

    &.device_status{
      font-size: 18px;
      vertical-align: middle;
      .mdi-access-point{
        color: #00a254;
      }
      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
  }

  .sim_status{
    width: 170px;
  }

  .device_name{
    &__line{
      display: flex;
      flex-direction: column;
    }
    a,p{
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}
</style>
